import React from "react";
import { VehiclePlate, BlueBar, Text, SubText, StatusText } from "./VehicleItemStyles";

interface Props {
  plate: string;
  clientName?: string;
  fleetDescription?: string;
  status?: any | null;
  showStatus?: boolean;
  setActivePlate?: (plate: string) => void;
}

const VehicleItem: React.FC<Props> = ({ plate, clientName, fleetDescription, status, showStatus = true, setActivePlate }: Props) => {
  const handleClick = () => {
    if (setActivePlate) {
      setActivePlate(plate);
    }
  };

  const statusMessage = status != null
    ? (typeof status === "string" ? status : status?.message ?? status?.description ?? JSON.stringify(status))
    : "Nenhum status disponível";

  return (
    <VehiclePlate onClick={handleClick}>
      <BlueBar />
      <Text>{plate}</Text>
      {clientName && <SubText>{clientName}{fleetDescription ? ` · ${fleetDescription}` : ""}</SubText>}
      {showStatus && <StatusText $hasStatus={status != null}>{statusMessage}</StatusText>}
    </VehiclePlate>
  );
};

export default VehicleItem;
